import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    searchChannel({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`youtube/search-channel`, params)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    getChannel({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`youtube/${params.channelRecordId}`, { params })
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    syncChannel({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('youtube/channel', params)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    distributeChannel({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`youtube/${params.channelId}/distribute`, params)
          .then((res) => resolve(res.data.channel))
          .catch((err) => reject(err))
      })
    },
    getComments({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`youtube/video/${id}/comments`)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
  },
  getters: {}
}